module.exports = __webpack_public_path__ + "media/photo/telico-391d1c88.png";